import React, { PureComponent } from "react";


class Query extends PureComponent {
  _isMounted = false;

  state = {
    data: {},
    loading: true,
    error: false
  };

  async componentDidMount() {
    this._isMounted = true;
    let { query } = this.props;
    try {
      let data = await query(1267);
      if (this._isMounted) {
        this.setState({ data, loading: false });
      }
    } catch (e) {
      if (this._isMounted) {
        this.setState({ error: e, loading: false });
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    let { children } = this.props;
    let { loading, error, data } = this.state;
    return <div>{children({ loading, error, data })}</div>;
  }
}

export default Query;
